import { useCallback, useEffect, useMemo } from "react";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { useToastOnAPIError } from "../api/useToastOnAPIError";
import { isParamNumeric } from "../utils/utils";

export const useGetYouthKidsByTeam = (teamId: number | string | undefined) => {
  const api = useAPI();
  const {
    data: youthKidGetData,
    state: youthKidGetState,
    error: youthKidGetError,
    query: youthKidGetQuery,
  } = useAPIQuery({ apiCall: api.youthKidGet });

  const youthKids = useMemo(
    () => youthKidGetData?.youthKids ?? [],
    [youthKidGetData?.youthKids]
  );

  useToastOnAPIError({
    error: youthKidGetError,
    title: `Unable to get youth kids for team ${teamId}`,
  });

  const queryYouthKids = useCallback(
    (forceQuery: boolean = false) => {
      if (youthKidGetState === "loading") {
        return;
      }
      if (youthKidGetData && !forceQuery) {
        return;
      }
      if (!teamId) {
        return;
      }
      if (typeof teamId === "string" && !isParamNumeric(teamId)) {
        return;
      }
      if (typeof teamId === "string") {
        youthKidGetQuery({ teamId: Number(teamId) });
        return;
      }
      youthKidGetQuery({ teamId });
    },
    [teamId, youthKidGetData, youthKidGetQuery, youthKidGetState]
  );

  useEffect(() => {
    queryYouthKids();
  }, [
    queryYouthKids,
    teamId,
    youthKidGetData,
    youthKidGetQuery,
    youthKidGetState,
  ]);

  return { youthKids, queryYouthKids };
};
